export default __webpack_public_path__ + "static/media/prophet-round-icon.0c4ca3a7.svg";